"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var types = _interopRequireWildcard(require("../../types"));

var sc = _interopRequireWildcard(require("./Dialog.styles"));

function Dialog(props) {
  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isAnimating = _React$useState2[0],
      setIsAnimating = _React$useState2[1];

  var refPanel = _react["default"].useRef(null);

  var a11yText = props.a11yText,
      children = props.children,
      footer = props.footer,
      getPushContentElement = props.getPushContentElement,
      groupOffsetY = props.groupOffsetY,
      onAnimationEnd = props.onAnimationEnd,
      header = props.header,
      kind = props.kind,
      isCompact = props.isCompact,
      isInline = props.isInline,
      offsetY = props.offsetY,
      onClose = props.onClose,
      refHeader = props.refHeader,
      refPanelContent = props.refPanelContent,
      width = props.width,
      isOpen = props.isOpen,
      isSlideFromLeft = props.isSlideFromLeft,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "children", "footer", "getPushContentElement", "groupOffsetY", "onAnimationEnd", "header", "kind", "isCompact", "isInline", "offsetY", "onClose", "refHeader", "refPanelContent", "width", "isOpen", "isSlideFromLeft"]);
  var isFooterSticky = footer && footer.props.isSticky;
  var isHeaderSticky = header && header.props.isSticky;

  var dialogMain = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(sc.DialogContent, {
    "data-pka-anchor": "panel.content",
    hasPushedElement: !!getPushContentElement,
    isCompact: isCompact,
    isOpen: isOpen,
    kind: kind,
    ref: refPanelContent,
    role: "region",
    tabIndex: "0"
  }, children));

  _react["default"].useEffect(function () {
    setIsAnimating(true);
  }, [isOpen]);

  var dialogFooter = footer ? /*#__PURE__*/_react["default"].cloneElement(footer, {
    refPanel: refPanel,
    isCompact: isCompact
  }) : null;
  var dialogHeader = header ? /*#__PURE__*/_react["default"].cloneElement(header, {
    ref: refHeader,
    isCompact: isCompact,
    onClose: onClose,
    getPushContentElement: getPushContentElement
  }) : null;

  var handleAnimationEnd = function handleAnimationEnd() {
    setIsAnimating(false);
    onAnimationEnd();
  };

  var renderDialogContent = function renderDialogContent() {
    return isFooterSticky || isHeaderSticky ? /*#__PURE__*/_react["default"].createElement(sc.Main, null, isHeaderSticky && dialogHeader, /*#__PURE__*/_react["default"].createElement(sc.DialogMain, null, !isHeaderSticky && dialogHeader, dialogMain, !isFooterSticky && dialogFooter), isFooterSticky && dialogFooter) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dialogHeader, dialogMain, dialogFooter);
  };

  return /*#__PURE__*/_react["default"].createElement(sc.Dialog, (0, _extends2["default"])({
    "aria-modal": isInline ? null : "true",
    "aria-label": a11yText,
    hasPushedElement: !!getPushContentElement,
    groupOffsetY: groupOffsetY,
    kind: kind,
    isCompact: isCompact,
    isInline: isInline,
    isOpen: isOpen,
    offsetY: offsetY,
    isAnimating: isAnimating,
    onAnimationEnd: handleAnimationEnd,
    ref: refPanel,
    role: "dialog",
    tabIndex: "-1",
    isSlideFromLeft: isSlideFromLeft,
    width: width
  }, moreProps), renderDialogContent());
}

Dialog.types = {
  kind: {
    DEFAULT: types.sidePanelKinds.DEFAULT,
    PRIMARY: types.sidePanelKinds.PRIMARY
  }
};
var propTypes = {
  a11yText: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  footer: _propTypes["default"].node,
  getPushContentElement: _propTypes["default"].func,
  groupOffsetY: _propTypes["default"].number,
  header: _propTypes["default"].node,
  kind: _propTypes["default"].oneOf([Dialog.types.kind.DEFAULT, Dialog.types.kind.CHILD]),
  isCompact: _propTypes["default"].bool,
  isInline: _propTypes["default"].bool,
  offsetY: _propTypes["default"].number,
  onAnimationEnd: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func,
  refHeader: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  }).isRequired,
  refPanelContent: _propTypes["default"].shape({
    current: _propTypes["default"].instanceOf(Element)
  }).isRequired,
  isSlideFromLeft: _propTypes["default"].bool,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  isOpen: _propTypes["default"].bool.isRequired
};
var defaultProps = {
  a11yText: null,
  footer: null,
  getPushContentElement: function getPushContentElement() {},
  groupOffsetY: 0,
  header: null,
  kind: Dialog.types.kind.DEFAULT,
  isCompact: false,
  isInline: false,
  offsetY: 0,
  onClose: function onClose() {},
  isSlideFromLeft: false
};
Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;
var _default = Dialog;
exports["default"] = _default;
//# sourceMappingURL=Dialog.js.map